<template>
  <div data-v-6bd700be="" data-v-e5781868="" class="home main mainContent top50" >
          <div data-v-791e476e="" data-v-d8ce3802="" data-v-e5781868="" class="mask register" style="" v-if="tanshow && $store.state.appInfo.index_modal == 1">
        <div data-v-791e476e="" data-v-d8ce3802="" class="panel panel2">
          <div data-v-791e476e="" data-v-d8ce3802="" class="close" @click="changtanshow"></div>
          <div data-v-791e476e="" data-v-d8ce3802="" class="group">
            <div data-v-791e476e="" data-v-d8ce3802="" class="tab">
              <a data-v-791e476e="" data-v-d8ce3802="" class="mobile active" style="margin-left: 0px">
                欢迎来到{{ $store.state.appInfo.title }}
                </a
              >
            </div>
            <div data-v-791e476e="" data-v-d8ce3802="" class="form">
              <div v-html="$store.state.appInfo.webcontent"></div>
            </div>
            <p data-v-791e476e="" data-v-d8ce3802="" class="note">*演示站222支持数字币存取 <span data-v-791e476e="" data-v-d8ce3802="">安全 · 便捷 · 秒到账</span></p>
          </div>
          <div data-v-791e476e="" data-v-56bf0195="" data-v-d8ce3802="" class="register-right-panel">
            <div data-v-791e476e="" data-v-56bf0195="" class="marquee">
              <div data-v-791e476e="" data-v-56bf0195="" class="marquee-title"><i data-v-791e476e="" data-v-56bf0195=""></i>15798人成功领取存款3重礼, 累计派发9307062.24USDT</div>
              <div data-v-791e476e="" data-v-56bf0195="" class="marquee-box" style="height: 112px">
                <div class="tempWrap" style="overflow: hidden; position: relative; height: 112px">
                  <ul data-v-791e476e="" data-v-56bf0195="" class="marquee-list" style="height: 560px; position: relative; padding: 0px; margin: 0px; top: -112px">
                    <li data-v-791e476e="" data-v-56bf0195="" class="clone" style="height: 28px">恭喜 ****an1会员存款 500.00USDT 领取 200.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****720会员存款 1,000.00USDT 领取 300.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****an1会员存款 5,000.00USDT 领取 1,750.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****an1会员存款 3,000.00USDT 领取 900.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****gge会员存款 30,000.00USDT 领取 10,500.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****888会员存款 3,000.00USDT 领取 900.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****c35会员存款 2,000.00USDT 领取 800.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****c35会员存款 2,000.00USDT 领取 700.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****111会员存款 3,000.00USDT 领取 900.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****612会员存款 500.00USDT 领取 200.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****050会员存款 10,000.00USDT 领取 3,000.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****d29会员存款 30,000.00USDT 领取 10,500.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****d29会员存款 10,000.00USDT 领取 3,000.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****gge会员存款 30,000.00USDT 领取 12,000.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****358会员存款 20,000.00USDT 领取 6,000.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" style="height: 28px">恭喜 ****an1会员存款 500.00USDT 领取 200.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" class="clone" style="height: 28px">恭喜 ****720会员存款 1,000.00USDT 领取 300.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" class="clone" style="height: 28px">恭喜 ****an1会员存款 5,000.00USDT 领取 1,750.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" class="clone" style="height: 28px">恭喜 ****an1会员存款 3,000.00USDT 领取 900.00USDT</li>
                    <li data-v-791e476e="" data-v-56bf0195="" class="clone" style="height: 28px">恭喜 ****gge会员存款 30,000.00USDT 领取 10,500.00USDT</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div id="redPacket"  v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow" >
      <i class="grab"  @click="$parent.goNav('/userredpacket')"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />

    </div>
    <div data-v-8ea00d66="" data-v-6bd700be="" class="announcements">
      <div data-v-8ea00d66="" class="content">
        <svg data-v-338e1447="" data-v-8ea00d66="" aria-hidden="true" class="svg-icon iconSpeaker">
          <use data-v-338e1447="" xlink:href="#icon-iconSpeaker"></use>
        </svg>
        <div data-v-8ea00d66="" class="message">
          <marquee data-v-8ea00d66="" direction="left" onmouseout="this.start();" onmouseover="this.stop();" class="left text">
            <a data-v-8ea00d66="" @click="$parent.goNav('/messages?type=1')" href="javascript:void(0);" v-for="(item, index) in homenoticelis" :key="index">{{ item }}</a>
          </marquee>
          <a data-v-8ea00d66="" class="btn" href="javascript:void(0);" @click="$parent.goNav('/messages?type=1')">更多</a>
        </div>
      </div>
    </div>
    <div data-v-57927282="" data-v-6bd700be="" class="homeBanner">
      <div data-v-57927282="" class="banner banner-unlogin" style="">
        <div data-v-57927282="" class="content">
          <div data-v-57927282="" class="bannerSwiper">
            <div data-v-57927282="" class="swiper-container swiper swiper-container-horizontal">
          
              <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
                <div data-v-57927282="" class="swiper-slide" style="width: 100%" v-for="(item, index) in bannerList" :key="index">
                  <div data-v-57927282="" class="imgOne">
                    <div data-v-57927282="" class="img"><img data-v-57927282="" :src="item.src" /></div>
                  </div>
                </div>
              </div>

              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <div data-v-57927282="" class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
              <span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1"></span><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2"></span
              ><span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3"></span>
            </div>
            <div data-v-57927282="" slot="button-prev" class="swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true">
              <svg data-v-338e1447="" data-v-57927282="" aria-hidden="true" class="svg-icon iconBannerPrev">
                <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
              </svg>
            </div>
            <div data-v-57927282="" slot="button-next" class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false">
              <svg data-v-338e1447="" data-v-57927282="" aria-hidden="true" class="svg-icon iconBannerNext">
                <use data-v-338e1447="" xlink:href="#icon-iconBannerPrev"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-6bd700be="" class="section section1">
      <div data-v-6bd700be="" class="content">
        <div data-v-6bd700be="" class="group">
          <div data-v-6bd700be="" class="img">
            <img data-v-6bd700be="" src="/static/image/img1.png_.0b93c5c8.webp" />
            <div data-v-6bd700be="" class="ring"><span data-v-6bd700be="" class="ring1"></span><span data-v-6bd700be="" class="ring2"></span><span data-v-6bd700be="" class="ring3"></span></div>
          </div>
          <div data-v-6bd700be="" class="info">
            <div data-v-6bd700be="" class="title"></div>
            <p data-v-6bd700be="">单注最高200万 豪客首选</p>
            <p data-v-6bd700be="">多台下注 盈利翻倍</p>
            <div data-v-6bd700be="" class="value">
              <p data-v-6bd700be="">在线人数</p>
              <h1 data-v-6bd700be="">2224<span data-v-6bd700be="">人</span></h1>
            </div>
          </div>
          <div data-v-6bd700be="" class="buttons">
            <a data-v-6bd700be="" class="button button2">
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconAg">
                <use data-v-338e1447="" xlink:href="#icon-iconAg"></use>
              </svg>
              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" @click="$parent.openGamePage('ag', '1', '')" data-hover="立即进厅" class="text"><span data-v-6bd700be="">国际厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <a data-v-6bd700be="" class="button button1">
              <img src="/static/image/bg.png" class="svg-icon icon iconAg imgIcon" alt="" />
            

              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" @click="$parent.openGamePage('bg', 'videogame', '')" data-hover="立即进厅" class="text"><span data-v-6bd700be="">旗舰厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <a data-v-6bd700be="" class="button button3"
              ><svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconMore">
                <use data-v-338e1447="" xlink:href="#icon-iconMore"></use>
              </svg>
              <div data-v-6bd700be="" class="inner">
                <div data-v-6bd700be="" class="text"><span data-v-6bd700be="" @click="$parent.goNav('/realPerson')">更多厅</span></div>
              </div>
              <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
          </div>
        </div>
     
        <div data-v-6bd700be="" class="row">
          <div data-v-6bd700be="" class="flexBox flexBox2">
            <div data-v-fb074588="" data-v-6bd700be="" class="col col1">
              <div data-v-fb074588="" class="t">
                <svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon icon iconCup">
                  <use data-v-338e1447="" xlink:href="#icon-iconCup"></use>
                </svg>
                盈利榜
              </div>
              <div data-v-fb074588="" class="box">
                <div data-v-fb074588="" class="table">
                  <table data-v-fb074588="">
                    <thead data-v-fb074588="">
                      <tr data-v-fb074588="">
                        <th data-v-fb074588="">实时排名</th>
                        <th data-v-fb074588="">用户名</th>
                        <th data-v-fb074588="">今日实时盈利</th>
                        <th data-v-fb074588="">盈利率</th>
                      </tr>
                    </thead>
                    <tbody data-v-fb074588="">
                      <tr data-v-fb074588="" class="active">
                        <td data-v-fb074588="">
                          <span data-v-fb074588=""
                            ><svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon medal medal1">
                              <use data-v-338e1447="" xlink:href="#icon-medal1"></use></svg
                          ></span>
                        </td>
                        <td data-v-fb074588="">****580</td>
                        <td data-v-fb074588="">14200.00 元</td>
                        <td data-v-fb074588="">63%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588="">
                          <span data-v-fb074588=""
                            ><svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon medal medal2">
                              <use data-v-338e1447="" xlink:href="#icon-medal2"></use></svg
                          ></span>
                        </td>
                        <td data-v-fb074588="">****888</td>
                        <td data-v-fb074588="">9477.25 元</td>
                        <td data-v-fb074588="">15%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588="">
                          <span data-v-fb074588=""
                            ><svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon medal medal3">
                              <use data-v-338e1447="" xlink:href="#icon-medal3"></use></svg
                          ></span>
                        </td>
                        <td data-v-fb074588="">****315</td>
                        <td data-v-fb074588="">9107.07 元</td>
                        <td data-v-fb074588="">19%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588=""><span data-v-fb074588="">4</span></td>
                        <td data-v-fb074588="">****533</td>
                        <td data-v-fb074588="">6340.00 元</td>
                        <td data-v-fb074588="">51%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588=""><span data-v-fb074588="">5</span></td>
                        <td data-v-fb074588="">****570</td>
                        <td data-v-fb074588="">4600.00 元</td>
                        <td data-v-fb074588="">17%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588=""><span data-v-fb074588="">6</span></td>
                        <td data-v-fb074588="">****234</td>
                        <td data-v-fb074588="">2972.00 元</td>
                        <td data-v-fb074588="">14%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588=""><span data-v-fb074588="">7</span></td>
                        <td data-v-fb074588="">****309</td>
                        <td data-v-fb074588="">2782.00 元</td>
                        <td data-v-fb074588="">26%</td>
                      </tr>
                      <tr data-v-fb074588="" class="">
                        <td data-v-fb074588=""><span data-v-fb074588="">8</span></td>
                        <td data-v-fb074588="">****602</td>
                        <td data-v-fb074588="">2664.00 元</td>
                        <td data-v-fb074588="">19%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div data-v-fb074588="" class="profit">
                  <div data-v-fb074588="" class="user-name-wrapper">
                    <div data-v-fb074588="" class="user-name">会员****580</div>
                  </div>
                  <h3 data-v-fb074588="">今日总盈利金额</h3>
                  <div data-v-fb074588="" class="amount">
                    <span data-v-fb074588="" class="icons"
                      ><svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon icon cny">
                        <use data-v-338e1447="" xlink:href="#icon-cny"></use></svg
                    ></span>
                    <h1 data-v-fb074588="">14200.00</h1>
                  </div>
                  <div data-v-fb074588="" class="records">
                    <h4 data-v-fb074588="">盈利记录</h4>
                    <table data-v-fb074588="">
                      <tbody>
                        <tr data-v-fb074588="">
                          <td data-v-fb074588="" width="79">旗舰厅</td>
                          <td data-v-fb074588="" width="34">--</td>
                          <td data-v-fb074588="" width="45">--</td>
                          <td data-v-fb074588="" width="78">盈利金额</td>
                          <td data-v-fb074588=""><span data-v-fb074588="">--</span></td>
                        </tr>
                        <tr data-v-fb074588="">
                          <td data-v-fb074588="" width="79">旗舰厅</td>
                          <td data-v-fb074588="" width="34">--</td>
                          <td data-v-fb074588="" width="45">--</td>
                          <td data-v-fb074588="" width="78">盈利金额</td>
                          <td data-v-fb074588=""><span data-v-fb074588="">--</span></td>
                        </tr>
                        <tr data-v-fb074588="">
                          <td data-v-fb074588="" width="79">旗舰厅</td>
                          <td data-v-fb074588="" width="34">--</td>
                          <td data-v-fb074588="" width="45">--</td>
                          <td data-v-fb074588="" width="78">盈利金额</td>
                          <td data-v-fb074588=""><span data-v-fb074588="">--</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <div data-v-fb074588="">
                      <h4 data-v-fb074588="" class="desc">正在旗舰厅 <span data-v-fb074588="">--桌</span> 投注…</h4>
                    </div>
                    <a data-v-fb074588="" class="button buttonBordered"
                      >跟注
                      <svg data-v-338e1447="" data-v-fb074588="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                    <div data-v-fb074588="" class="total">
                      <p data-v-fb074588="">平均到账时间: <span data-v-fb074588="">57分钟</span></p>
                      <p data-v-fb074588="">正在处理取款: <span data-v-fb074588="">59笔</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-0a3f7497="" data-v-6bd700be="" class="col col3" v-if="false">
              <div data-v-0a3f7497="" class="t">
                <svg data-v-338e1447="" data-v-0a3f7497="" aria-hidden="true" class="svg-icon icon iconGame">
                  <use data-v-338e1447="" xlink:href="#icon-iconGame"></use></svg
                >电竞投注
              </div>
              <div data-v-0a3f7497="" class="c">
                <div data-v-0a3f7497="" class="item item1">
                  <div data-v-0a3f7497="" class="item-bg"><span data-v-0a3f7497="" class="mask"></span></div>
                  <div data-v-0a3f7497="" class="img"><img data-v-0a3f7497="" src="/static/image/gpas_tsgift_pop.jpg_.webp" lazy="loaded" /></div>
                  <div data-v-0a3f7497="" class="info">
                    <h3 data-v-0a3f7497="">小艾电竞</h3>
                    <p data-v-0a3f7497="">人气值:20493</p>
                    <a data-v-0a3f7497="" class="button buttonBordered" @click="$parent.openGamePage('ia', '2', '')"
                      >立即前往
                      <svg data-v-338e1447="" data-v-0a3f7497="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <div data-v-0a3f7497="" class="item item2">
                  <div data-v-0a3f7497="" class="item-bg"><span data-v-0a3f7497="" class="mask"></span></div>
                  <div data-v-0a3f7497="" class="img"><img data-v-0a3f7497="" src="/static/image/1103.jpg_.webp" lazy="loaded" /></div>
                  <div data-v-0a3f7497="" class="info">
                    <h3 data-v-0a3f7497="">雷火电竞</h3>
                    <p data-v-0a3f7497="">人气值:18414</p>
                    <a data-v-0a3f7497="" class="button buttonBordered" @click="$parent.openGamePage('ld', '2', '')"
                      >立即前往
                      <svg data-v-338e1447="" data-v-0a3f7497="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <div data-v-0a3f7497="" class="item item3">
                  <div data-v-0a3f7497="" class="item-bg"><span data-v-0a3f7497="" class="mask"></span></div>
                  <div data-v-0a3f7497="" class="img"><img data-v-0a3f7497="" src="/static/image/bfb.jpg_.webp" lazy="loaded" /></div>
                  <div data-v-0a3f7497="" class="info">
                    <h3 data-v-0a3f7497="">泛亚电竞</h3>
                    <p data-v-0a3f7497="">人气值:16929</p>
                    <a data-v-0a3f7497="" class="button buttonBordered" @click="$parent.openGamePage('avia', '2', '')"
                      >立即前往
                      <svg data-v-338e1447="" data-v-0a3f7497="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <div data-v-0a3f7497="" class="item item3">
                  <div data-v-0a3f7497="" class="item-bg"><span data-v-0a3f7497="" class="mask"></span></div>
                  <div data-v-0a3f7497="" class="img"><img data-v-0a3f7497="" src="/static/image/bfb.jpg_.webp" lazy="loaded" /></div>
                  <div data-v-0a3f7497="" class="info">
                    <h3 data-v-0a3f7497="">OB电竞</h3>
                    <p data-v-0a3f7497="">人气值:16929</p>
                    <a data-v-0a3f7497="" class="button buttonBordered" @click="$parent.openGamePage('obgdj', '2', '')"
                      >立即前往
                      <svg data-v-338e1447="" data-v-0a3f7497="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-6bd700be="" class="row">
          <div data-v-6bd700be="" class="t">
            <svg data-v-338e1447="" data-v-6bd700be="" aria-hidden="true" class="svg-icon icon iconServices">
              <use data-v-338e1447="" xlink:href="#icon-iconServices"></use>
            </svg>
            特色服务
          </div>
          <div data-v-6bd700be="" class="flexBox">
            <div data-v-6bd700be="" class="service">
              <img data-v-6bd700be="" src="/static/image/service1.png_.d54c8489.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">过夜利息</h2>
                <p data-v-6bd700be="">最高年利率36%，收益日结</p>
              </div>
            </div>
            <div data-v-6bd700be="" class="service">
              <img data-v-6bd700be="" src="/static/image/service2.png_.a9348920.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">股东日</h2>
                <p data-v-6bd700be="">每月8/18/28爽领分红、贷款</p>
              </div>
            </div>
            <div data-v-6bd700be="" class="service" @click="$parent.goNav('/details')">
              <img data-v-6bd700be="" src="/static/image/service3.png_.b1d69432.webp" />
              <div data-v-6bd700be="" class="info">
                <h2 data-v-6bd700be="">超级合伙人</h2>
                <p data-v-6bd700be="">三层抽佣模式 佣金拿到手抽筋</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-03c2c755="" data-v-6bd700be="" class="k8BrandWay">
      <div data-v-03c2c755="" class="content">
        <div data-v-03c2c755="" class="t">
          <svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconPromos">
            <use data-v-338e1447="" xlink:href="#icon-iconPromos"></use>
          </svg>
          品牌历程
        </div>
      </div>
      <div data-v-03c2c755="" class="c">
        <div data-v-03c2c755="" class="content">
          <div data-v-03c2c755="" class="timeline">
            <a data-v-03c2c755="" slot="button-prev" class="tool prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconPrev">
                <use data-v-338e1447="" xlink:href="#icon-iconPrev"></use></svg
            ></a>
            <div data-v-03c2c755="" class="swiper-container swiper swiper-container-initialized swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState" style="width: 20.43%"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item active">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2021</h3>
                          <p data-v-03c2c755="">09月16日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">07月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2020</h3>
                          <p data-v-03c2c755="">02月09日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2019</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2018</h3>
                          <p data-v-03c2c755="">10月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2017</h3>
                          <p data-v-03c2c755="">12月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">11月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">09月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">05月02日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">05月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2016</h3>
                          <p data-v-03c2c755="">12月25日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">08月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">07月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">03月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2015</h3>
                          <p data-v-03c2c755="">12月30日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2014</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">04月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">01月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <h3 data-v-03c2c755="">2013</h3>
                          <p data-v-03c2c755="">11月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">10月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 942px">
                  <div data-v-03c2c755="" class="swiper-content">
                    <div data-v-03c2c755="" class="line">
                      <div data-v-03c2c755="" class="activeState"></div>
                    </div>
                    <div data-v-03c2c755="" class="items">
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">06月01日</p>
                        </div>
                      </div>
                      <div data-v-03c2c755="" class="item">
                        <div data-v-03c2c755="" class="bullet">
                          <p data-v-03c2c755="">02月01日</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <a data-v-03c2c755="" slot="button-next" class="tool next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"
              ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon iconNext">
                <use data-v-338e1447="" xlink:href="#icon-iconNext"></use></svg
            ></a>
          </div>
          <div data-v-03c2c755="" class="box">
            <svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute1">
              <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute1"></use></svg
            ><svg data-v-338e1447="" data-v-03c2c755="" aria-hidden="true" class="svg-icon icon iconDoubleQoute2">
              <use data-v-338e1447="" xlink:href="#icon-iconDoubleQoute2"></use>
            </svg>
            <div data-v-03c2c755="" class="swiper-img swiper-no-swiping swiper-container-horizontal" style="cursor: grab">
              <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-active" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购乐橙娱乐</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}正式收购乐橙娱乐，强强联手 携手共赢 实力见证</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" src="/static/image/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide swiper-slide-next" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约两位巨星球员</h3>
                      <p data-v-03c2c755="">卢卡斯•波多尔斯基及韦斯利•斯内德正式成为{{$store.state.appInfo.title}}品牌代言人，实力升级，信誉保障</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" src="/static/image/banner-brand-1807be7465a2b4997342d4f285407348f.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约意甲卡利亚里足球俱乐部</h3>
                      <p data-v-03c2c755="">卡利亚里足球俱乐部正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" src="/static/image/banner-brand-24e9c47e6fc3cfcc507423a2e284c3a26.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}收购暴风竞技</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式收购暴风竞技，为业界全方位多元化布局打下坚实基础</p>
                    </div>
                    <div data-v-03c2c755="" class="promo"><img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" src="/static/image/banner-brand-3668efe1a12572b15279d2a190e700de9.png_.webp" /></div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">梦想基金助力湖北 为武汉加油</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}梦想基金会捐赠人民币200万给韩红爱心慈善基金会，正能量满满，一起为武汉加油</p>
                    </div>
                    <div data-v-03c2c755="" class="promo"><img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" src="/static/image/banner-brand-44ada73c49cd997556c3cbb9e643e9b03.png_.webp" /></div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}捐赠物资对抗菲律宾百火山</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐爱心传递 公益先行 为社会救助送暖</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" src="/static/image/banner-brand-563eb193a272561a3de9b9836a2685179.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">德甲劲旅沙尔克04给您拜年了</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐合作伙伴 德甲劲旅沙尔克04祝您新年快乐 财源广进</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" src="/static/image/banner-brand-68f8f87dab2c917c5fc281224afcbb6bb.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2019年度传记</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐2019年年度报告，邀您一同见证{{$store.state.appInfo.title}}年度巅峰事迹</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" src="/static/image/banner-brand-7c9486d7cbb9ab8f390decd6570e5be26.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助陈小春巡回演唱会</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐携手龙门联合赞助陈小春STOP ANGRY演唱会</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" src="/static/image/banner-brand-8184af4a0586a8970af5e7440fb8d8340.png_.webp" lazy="loaded" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2019{{$store.state.appInfo.title}}百家乐现场争霸赛</h3>
                      <p data-v-03c2c755="">第二届{{$store.state.appInfo.title}}百家乐大赛赌王誕生 精彩赛事 奖金不断</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo"><img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-96825df2771c3ab757db0239b0fde19d7.png_.webp" src="/static/image/banner-brand-96825df2771c3ab757db0239b0fde19d7.png_.webp" /></div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐LOGO全新上线</h3>
                      <p data-v-03c2c755="">全新形象升级上线 新LOGO新气象 崭新面貌重新出发</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" src="/static/image/banner-brand-10ed97b7186b5eaa3e75284448ccc91a37.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约菲律宾及马尔代夫国家队</h3>
                      <p data-v-03c2c755="">菲律宾及马尔代夫国家队正式成为{{$store.state.appInfo.title}}娱乐的官方合作伙伴</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" src="/static/image/banner-brand-11472c225b9c695377442dafc5ad28647c.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐助力官方合作伙伴沙尔克04</h3>
                      <p data-v-03c2c755="">恭喜沙尔克04足球俱乐部在2019-2020新赛季再创佳绩</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" src="/static/image/banner-brand-12f71dc2e001a91668725f24bcca71a819.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">AG平台首家开设200万限红</h3>
                      <p data-v-03c2c755="">业界首创 提供您至尊体验 豪客首选不容错过</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" src="/static/image/banner-brand-133fe81aa347be2294f93e18573a6d1fa6.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2018年度传记</h3>
                      <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2018精采纪事 我们持续陪伴 为您生活增添更多精采</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" src="/static/image/banner-brand-14799bd63b7b53b16c3a5a63b7558b443e.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐收购悦博体育</h3>
                      <p data-v-03c2c755="">2018行业先锋 携手新老成员一起向前行</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" src="/static/image/banner-brand-15a2c1101b60458ee264e03185126e5a24.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐正式推出USDT数字币</h3>
                      <p data-v-03c2c755="">最稳定最保值的货币，资金永不冻结 不受银行监管，安全又方便</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-169bc91c7ec4b0e7d3efeb1e2f3dfa0ab7.png_.webp" src="/static/image/banner-brand-169bc91c7ec4b0e7d3efeb1e2f3dfa0ab7.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约明星球员Henry（亨利）</h3>
                      <p data-v-03c2c755="">法国史上进球最多的球员-亨利正式成为{{$store.state.appInfo.title}}娱乐品牌代言人</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-179189eb61e2d492048f3d12ff9baa2e3f.png_.webp" src="/static/image/banner-brand-179189eb61e2d492048f3d12ff9baa2e3f.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助周杰伦地表最强2世界巡回演唱会</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐冠名赞助，邀请百位会员一同感受周董的现场魅力</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-18065fc6253e8381fc31897cfa92b6c0e0.png_.webp" src="/static/image/banner-brand-18065fc6253e8381fc31897cfa92b6c0e0.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2017年度传记</h3>
                      <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2017精采纪事 携手共同成长 打造更坚实的游戏平台</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-199b38df47a9ae1d94f670e0d6a2ca1f37.png_.webp" src="/static/image/banner-brand-199b38df47a9ae1d94f670e0d6a2ca1f37.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}・梦想基金正式成立</h3>
                      <p data-v-03c2c755="">走心・助梦，{{$store.state.appInfo.title}}娱乐致力于回馈社会，助力体育事业的全方位慈善公益</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-202e19647309672582edfeb529c0cee2fc.png_.webp" src="/static/image/banner-brand-202e19647309672582edfeb529c0cee2fc.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐与曼城合办球迷见面会</h3>
                      <p data-v-03c2c755="">于中国深圳举办球迷见面会，邀请会员现场亲见球员 共度美好的时光</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-21bdd8d0d15a603d2681d8e6cdff960ca6.png_.webp" src="/static/image/banner-brand-21bdd8d0d15a603d2681d8e6cdff960ca6.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">AG{{$store.state.appInfo.title}}之夜</h3>
                      <p data-v-03c2c755="">专为龙门会员定制的私人狂欢派对，顶级俱乐部会员独享HM男人装泳池PARTY</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-22a7b3685790062f6d3e4966df67f5e462.png_.webp" src="/static/image/banner-brand-22a7b3685790062f6d3e4966df67f5e462.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约卡迪夫城足球俱乐部</h3>
                      <p data-v-03c2c755="">卡迪夫城足球俱乐部正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-23af1aee2c4eae53a8bbf07594f8d9dd54.png_.webp" src="/static/image/banner-brand-23af1aee2c4eae53a8bbf07594f8d9dd54.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约英超曼城德甲沙尔克04</h3>
                      <p data-v-03c2c755="">德甲沙尔克04正式成为{{$store.state.appInfo.title}}官方合作伙伴</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-2464d8dd60a50c93485ed361826f96e0c2.png_.webp" src="/static/image/banner-brand-2464d8dd60a50c93485ed361826f96e0c2.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}手机APP全新上线</h3>
                      <p data-v-03c2c755="">支持安卓、苹果系统，用指尖快速畅游{{$store.state.appInfo.title}}，一次下载 永久享用</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-251edd707c4781d4bddda3b71df745b7dd.png_.webp" src="/static/image/banner-brand-251edd707c4781d4bddda3b71df745b7dd.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2017{{$store.state.appInfo.title}}网页改版上线</h3>
                      <p data-v-03c2c755="">全新改版震撼登场，功能更齐全，服务更周到，致力打造最优质的游戏环境</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-266861ac3c5686d9045b8cd25d189ae04d.png_.webp" src="/static/image/banner-brand-266861ac3c5686d9045b8cd25d189ae04d.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助西布朗俱乐部举办足球宝贝大赛</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助足球宝贝大赛，传递青春、美丽、积极及健康的生活方式</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-271f2635f246cfb3930ccbc1b399a91d30.png_.webp" src="/static/image/banner-brand-271f2635f246cfb3930ccbc1b399a91d30.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2016年度报告</h3>
                      <p data-v-03c2c755="">邀您回顾{{$store.state.appInfo.title}}娱乐2016精采纪事 携手共同成长 打造更坚实的游戏平台</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-289c01977475203ea9abb22434125bb99a.png_.webp" src="/static/image/banner-brand-289c01977475203ea9abb22434125bb99a.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}冠名罗志祥疯狂世界巡回演唱会</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助罗志祥CRAZY WORLD演唱会香港站，邀请会员现场狂欢</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-29e67f6d66556f9f00168749ab35bb40f0.png_.webp" src="/static/image/banner-brand-29e67f6d66556f9f00168749ab35bb40f0.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">2016{{$store.state.appInfo.title}}娱乐杯 全民健身日・足球慈善赛</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐杯爱满人间 情满人心，援助30名足球特困生进行捐资助学</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-308e86d7e16107402ef24cf5559aed58c8.png_.webp" src="/static/image/banner-brand-308e86d7e16107402ef24cf5559aed58c8.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助英超西布朗维奇俱乐部</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐宣布成为西布朗维奇足球俱乐部官方主赞助商</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-315bed8c813af3f3fdb82c8214ab591364.png_.webp" src="/static/image/banner-brand-315bed8c813af3f3fdb82c8214ab591364.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}手机APP全新上线</h3>
                      <p data-v-03c2c755="">一次下载 永久享用，提供给您更快速、便利的游戏环境</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-32b381c0a46efc3fb44c9e5ec06fac57f8.png_.webp" src="/static/image/banner-brand-32b381c0a46efc3fb44c9e5ec06fac57f8.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助陈奕迅2015-16跨年演唱会澳門站</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐赞助陳奕迅跨年演唱会澳门站，與會員一同现场感受歌王的魅力</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-339c6a23c05928eeb15ebe766b278477d6.png_.webp" src="/static/image/banner-brand-339c6a23c05928eeb15ebe766b278477d6.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助2015美洲杯</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐成为2015唯一在线博彩的美洲杯亚洲区官方赞助商</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3409aca329ff967117e576ae115b26b482.png_.webp" src="/static/image/banner-brand-3409aca329ff967117e576ae115b26b482.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}续约米夏埃尔•巴拉克</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐与前德国国家队队长续约， 正式成为{{$store.state.appInfo.title}}品牌代言人</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3586a44a3c5870c67fd357b7baf8bba615.png_.webp" src="/static/image/banner-brand-3586a44a3c5870c67fd357b7baf8bba615.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助第三届老甲A</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐荣誉赞助第三届老甲A,带领会员重温经典，完美收官</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-36131fffc6de2c4507a48f6e7bc6a82cb0.png_.webp" src="/static/image/banner-brand-36131fffc6de2c4507a48f6e7bc6a82cb0.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}签约米夏埃尔•巴拉克</h3>
                      <p data-v-03c2c755="">前德国国家队队长米夏埃尔・巴拉客正式成为{{$store.state.appInfo.title}}娱乐品牌代言人</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-373f331e997858cf24af7e935813a81615.png_.webp" src="/static/image/banner-brand-373f331e997858cf24af7e935813a81615.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}赞助昆仑决赛4</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐独家赞助昆仑决4世界格斗冠军赛</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-387c9a0a9b8c38c83439279c7703773e8e.png_.webp" src="/static/image/banner-brand-387c9a0a9b8c38c83439279c7703773e8e.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">{{$store.state.appInfo.title}}举办AV女优荷官周</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐邀您共赴日本东京游，了解不一样的波多野结衣</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-3931b126ab92e836e3a27594ecf44c678a.png_.webp" src="/static/image/banner-brand-3931b126ab92e836e3a27594ecf44c678a.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">赞助60周年澳门格兰披治大赛车兰博基尼</h3>
                      <p data-v-03c2c755="">{{$store.state.appInfo.title}}娱乐激情赞助 相约澳门一同共襄盛举</p>
                      <a data-v-03c2c755="" class="link">了解详情</a>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-407234d822784320897524ca46fdfed034.png_.webp" src="/static/image/banner-brand-407234d822784320897524ca46fdfed034.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">利博亚洲正式更名为{{$store.state.appInfo.title}}娱乐</h3>
                      <p data-v-03c2c755="">新名称、新气象，全新出发带您迈向更好的未来</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-41cf0664e121329e0fe25509c671357e90.png_.webp" src="/static/image/banner-brand-41cf0664e121329e0fe25509c671357e90.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">行业首创6张牌先发</h3>
                      <p data-v-03c2c755="">首创6张牌先发 业界第一创新先驱</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-42005122a27183b1e97a95a5b70c1014ee.png_.webp" src="/static/image/banner-brand-42005122a27183b1e97a95a5b70c1014ee.png_.webp" />
                    </div>
                  </div>
                </div>
                <div data-v-03c2c755="" class="swiper-slide" style="width: 1004px">
                  <div data-v-03c2c755="" class="contentWraper">
                    <div data-v-03c2c755="" class="info">
                      <h3 data-v-03c2c755="">行业首家推出包桌百家乐</h3>
                      <p data-v-03c2c755="">首创包桌百家乐 带给您全新的体验</p>
                    </div>
                    <div data-v-03c2c755="" class="promo">
                      <img data-v-03c2c755="" data-src="https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/_wms/img/_l/_banner/banner-brand-43db01244ce029f7e155036a2d0629e1a6.png_.webp" src="/static/image/banner-brand-43db01244ce029f7e155036a2d0629e1a6.png_.webp" />
                    </div>
                  </div>
                </div>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-9a4a8610="" data-v-6bd700be="" style="display: none">
      <div data-v-9a4a8610="" class="usdtBackdrop" style="display: none">
        <div data-v-9a4a8610="" class="popUSDT" style="display: none">
          <div data-v-9a4a8610="" class="topSect">温馨提示 <a data-v-9a4a8610="" class="close"></a></div>
          <div data-v-9a4a8610="" class="midSect">
            <div data-v-9a4a8610="" class="text">USDT账户已与人民币账户结合，详情如下</div>
            <div data-v-9a4a8610="" class="text"><b data-v-9a4a8610="">USDT额度：0</b><b data-v-9a4a8610="">兑换额度：0</b></div>
            <div data-v-9a4a8610="" class="btnCon"><a data-v-9a4a8610="" class="btn">立即兑换</a><a data-v-9a4a8610="" class="btn">查看余额</a></div>
            <div data-v-9a4a8610="" class="text2">*汇率将会实时更新实际以到账金额为主</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return { homenoticelis: [], bannerList: [] ,hongbashow:true,
      tanshow: true,
    
    };
  },
  created() {
    let that = this;
    that.homenotice(); 
    that.getBanList(); 
  },
  methods: {
            changtanshow() {
      this.tanshow = !this.tanshow;
    },
            changhongbashow() {
      this.hongbashow = false;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;

    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.banner .bannerSwiper .swiper .swiper-slide .imgOne[data-v-57927282] {
  height: auto !important;
}
.banner .bannerSwiper[data-v-57927282] {
  height: auto !important;
}
.banner .bannerSwiper .swiper .swiper-slide[data-v-57927282] {
  height: auto !important;
}
.banner[data-v-57927282] {
  height: auto !important;
}
.imgIcon {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.1rem;
  vertical-align: middle;
  position: absolute;
  left: 0.5rem;
  // filter: grayscale(100%);
}
.banner .content[data-v-57927282] {
  padding-top: 0.2rem;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col3 .item {
  width: 100%;
  height: 1.22rem;
  background: #2e3138;
  border-radius: 0.08rem;
  margin-bottom: 0.05rem;
  padding: 0.1rem;
  position: relative;
  overflow: hidden;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col1 {
  padding: 0;
  width: 100%;
}
.home .section.section1 .row .flexBox.flexBox2[data-v-6bd700be] .col.col1 .box .table {
  width: 8.4rem;
  height: 4.62rem;
  background: #191a1f;
  border-radius: 0.08rem;
  display: inline-block;
  margin-right: 0.16rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue